/* cf-sticky-header.js — masque le header au défilement vers le bas, le révèle
   au défilement vers le haut. Amélioration pure : sans ce fichier, le header
   reste collé en haut par `position: sticky`, rien n'est perdu.
   Une responsabilité, un fichier (docs/06 §5). */

class CfStickyHeader extends HTMLElement {
  connectedCallback() {
    this.header = this.querySelector('.cf-header');
    if (!this.header || this.header.dataset.sticky !== 'on_scroll_up') return;

    this.lastScroll = window.scrollY;
    this.ticking = false;
    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  disconnectedCallback() {
    if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;

    window.requestAnimationFrame(() => {
      const current = window.scrollY;
      const goingDown = current > this.lastScroll;

      if (goingDown && current > this.header.offsetHeight) {
        this.header.setAttribute('data-hidden', '');
      } else {
        this.header.removeAttribute('data-hidden');
      }

      this.lastScroll = current;
      this.ticking = false;
    });
  }
}

if (!customElements.get('cf-sticky-header')) {
  customElements.define('cf-sticky-header', CfStickyHeader);
}
